import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          糖心视频、黑桃视频、妖精视频等平台实时更新快讯
        </p>

        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/60 hidden sm:block"></div>
          <div className="space-y-0">
            {updatesData.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 py-3.5 pl-0 sm:pl-10">
                <div className="hidden sm:flex absolute left-[15px] top-5 w-2.5 h-2.5 rounded-full bg-primary-400 border-2 border-background-100 flex-shrink-0"></div>
                <div className="flex-shrink-0 sm:hidden w-8">
                  <div className="w-2.5 h-2.5 mt-1.5 rounded-full bg-primary-400"></div>
                </div>
                <div className="flex-1 min-w-0 bg-background-50 border border-background-200/70 rounded-lg p-3.5 md:p-4 hover:border-primary-200/60 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 text-xs font-semibold rounded-full whitespace-nowrap ${
                      item.tag === '上新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热门' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '更新' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '功能' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-500'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}